import EmptyState from '../components/EmptyState';

export default function Dramas() {
  return (
    <EmptyState
      title="Dramas"
      description="Multi-character drama scripts with scene direction"
      phase={8}
    />
  );
}
